import { render, staticRenderFns } from "./commingSoon.vue?vue&type=template&id=26cf7287&"
import script from "./commingSoon.vue?vue&type=script&lang=js&"
export * from "./commingSoon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports